import { Strong } from '@ahmdigital/ui';

import { percentages } from '../../constants';
import styles from './styles.module.sass';

const tipFormatter = (value: number) => (
  <div>
    <Strong variant={[styles.tooltip]}>{(percentages[value] || 0) * 100}%</Strong>
    <div className={styles.tooltipTitle}>
      youth <br />
      discount
    </div>
  </div>
);

export default tipFormatter;
